<div class="user-details-container">
  <div class="container-fluid">
    <div class="row g-6 mb-6"></div>
    <div class="table-container">
      <div
        class="user-details-title d-flex justify-content-between align-items-center"
      >
        <h5>Detalii utilizator</h5>
      </div>
      <div class="user-details">
        <table>
          <tr>
            <td>Nume:</td>
            <td>{{ userDetailsData?.firstName }}</td>
          </tr>
          <tr>
            <td>Prenume:</td>
            <td>{{ userDetailsData?.lastName || "-" }}</td>
          </tr>
          <tr>
            <td>E-mail:</td>
            <td>{{ userDetailsData?.email || "-" }}</td>
          </tr>
          <tr>
            <td>
              {{
                licensePlatesData.length > 1
                  ? "Numere de înmatriculare"
                  : "Număr de înmatriculare"
              }}:
            </td>
            <td>
              <span *ngFor="let licensePlate of licensePlatesData">
                {{ licensePlate.licensePlate }}</span
              >
            </td>
          </tr>
          <tr>
            <td>Tichete cumpărate:</td>
            <td>{{ ticketCount }}</td>
          </tr>
          <!-- <tr>
            <td>Abonamente active:</td>
            <td><span *ngFor="let activeSubscription of activeSubscriptionsData">
                {{ activeSubscription.licensePlate }} - </span
              ></td>
          </tr> -->
        </table>
      </div>
    </div>
    <div>
      <div
        class="card mt-2"
        *ngFor="let activeSubscription of activeSubscriptionsData"
      >
        <div class="card-header">{{ activeSubscription.licensePlate }}</div>
        <!-- <ul class="list-group list-group-flush">
          <li
            class="list-group-item"
            *ngFor="let subscription of activeSubscription.subscriptions"
          >
            {{ subscription.startDate | date : "yyyy-MM-dd HH:mm:ss" : "GMT" }}
            -
            {{ subscription.endDate | date : "yyyy-MM-dd HH:mm:ss" : "GMT" }}
            :
            {{ subscription.description }}
          </li>
        </ul> -->
        <table>
          <tr style="border-bottom: 1px solid rgba(0, 0, 0, 0.175)">
            <td>Abonament</td>
            <td>Perioada</td>
          </tr>
          <tr *ngFor="let subscription of activeSubscription.subscriptions">
            <td>{{ subscription.description }}</td>
            <td>
              {{
                subscription.startDate | date : "yyyy-MM-dd HH:mm:ss" : "GMT"
              }}
              -
              {{ subscription.endDate | date : "yyyy-MM-dd HH:mm:ss" : "GMT" }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>
